export default {
    type: 'panel',
    name: 'pricingTiers',
    blocks: [
        {
            name: 'eyebrow',
            label: 'Sur-titre',
            max: 1,
            type: 'text',
        },
        {
            name: 'title',
            label: 'Titre',
            max: 1,
            type: 'text',
        },
        {
            name: 'intro',
            label: 'Introduction',
            max: 1,
            type: 'html',
        },
        // Row labels are fixed UI strings rendered via FormattedMessage in the viewer, not editable
        // per panel (see PanelPricingTiers.js + Intl/localizationData).
        {
            name: 'tiers',
            label: 'Formules',
            type: 'mixed',
            blocks: [
                { name: 'name', label: 'Nom de la formule', max: 1, type: 'text' },
                { name: 'audience', label: 'Cible (une phrase)', max: 1, type: 'text' },
                { name: 'discount', label: 'Remise (ex : −45 %)', max: 1, type: 'text' },
                { name: 'minimum', label: 'Commande minimum', max: 1, type: 'text' },
                { name: 'franco', label: 'Livraison offerte', max: 1, type: 'text' },
                { name: 'packaging', label: 'Conditionnement', max: 1, type: 'text' },
                { name: 'idealFor', label: 'Idéal pour', max: 1, type: 'text' },
                { name: 'cta', label: 'Bouton (texte + lien)', max: 1, type: 'link' },
                { name: 'ribbon', label: 'Badge de mise en avant (optionnel)', max: 1, type: 'text' },
                { name: 'color', label: 'Couleur (bouton, badge, prix)', max: 1, type: 'select', options: ['warning', 'danger', 'success', 'primary', 'secondary', 'info', 'light', 'dark'] },
            ],
        },
        {
            name: 'footnote',
            label: 'Note de bas',
            max: 1,
            type: 'html',
        },
    ],
};
